export const UI = {
  Auth: {
    IsLoading: 'Auth.IsLoading',
    Signin: {
      ErrorMessages: 'Auth.Signin.ErrorMessages',
    },
    Signup: {
      ErrorMessages: 'Auth.Signup.ErrorMessages',
    },
  },
  Datasets: {
    IsFetching: 'Datasets.IsFetching',
    IsCreating: 'Datasets.IsCreating',
    IsUpdating: 'Datasets.IsUpdating',
    CreateDialogVisible: 'Datasets.CreateDialogVisible',
    UpdateDialogVisible: 'Datasets.UpdateDialogVisible',
  },
  UserProfile: {
    DialogVisible: 'UserProfile.DialogVisible',
    IsProfileCreating: 'UserProfile.IsProfileCreating',
    IsProfileUpdating: 'UserProfile.IsProfileUpdating',
    IsCoverPhotoUploading: 'UserProfile.IsCoverPhotoUploading',
    IsProfilePhotoUploading: 'UserProfile.IsProfilePhotoUploading',
    IsWidgetsSettingsUpdating: 'UserProfile.IsWidgetsSettingsUpdating',
  },
  Arts: {
    IsFetching: 'Arts.IsFetching',
  },
  Artsets: {
    IsFetching: 'Artsets.IsFetching',
    IsCreating: 'Artsets.IsCreating',
    IsUpdating: 'Artsets.IsUpdating',
    AddingImages: 'Artsets.AddingImages',
    IsAddingImages: 'Artsets.IsAddingImages',
    IsAddingCoverImage: 'Artsets.IsAddingCoverImage',
    IsPublishing: 'Artsets.IsPublishing',
    IsUnpublishing: 'Artsets.IsUnpublishing',
  },
};
